import React from 'react';
import PropTypes from 'prop-types';
import IconMenu from 'material-ui/IconMenu';
import LogoutMenuItem from 'components/layout/Layout/header/userMenu/LogoutMenuItem';
import MenuItem from 'material-ui/MenuItem';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { LockIcon, SettingsIcon } from 'assets/materialIcons/materialIcons';
import { Link, withRouter } from 'react-router-dom';
import UserAvatar from 'components/ui/general/UserAvatar';
import { IconButton } from 'material-ui';
import styled from 'styled-components';
import AssignmentTurnedInIcon from 'material-ui/svg-icons/action/assignment-turned-in';

const StyledIconButton = styled(IconButton)`
    padding: 0px !important;
`;

const Avatar = React.createElement(UserAvatar);

class UserMenu extends React.PureComponent {
    render() {
        const {
            history,
            translate,
        } = this.props;

        return (
            <IconMenu
                iconButtonElement={ React.createElement(StyledIconButton, null, Avatar) }
                anchorOrigin={ { horizontal: 'right', vertical: 'bottom' } }
                targetOrigin={ { horizontal: 'right', vertical: 'top' } }
            >
                <MenuItem
                    containerElement={ <Link to={ `/@me/profile` } /> }
                    primaryText={ translate('menu.topbar.profile') }
                    leftIcon={ <SettingsIcon /> }
                />

                <MenuItem
                    containerElement={ <Link to={ `/@me/invitations` } /> }
                    primaryText={ translate('resources.invitations.title') }
                    leftIcon={ <AssignmentTurnedInIcon /> }
                />

                <MenuItem
                    containerElement={ <Link to={ `/@me/security` } /> }
                    primaryText={ translate('menu.topbar.security') }
                    leftIcon={ <LockIcon /> }
                />

                <LogoutMenuItem
                    history={ history }
                />
            </IconMenu>
        );
    }
}

UserMenu.propTypes = {
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    withRouter,
    translate,
);

export default enhance(UserMenu);



// WEBPACK FOOTER //
// ./src/components/layout/Layout/header/UserMenu.js